import React from 'react';
import { BrowserRouter } from 'react-router-dom';

const Avatar = () => {
    return (
        <BrowserRouter>
            <div className="Avatar">
                
            </div>
        </BrowserRouter>
    );
};

export default Avatar;